import { useCallback } from 'react';
import { configFetch as fetch } from '@meiqia/utils';
import { useDispatch, useSelector } from '../../../react-redux';
import { setMarketingPerm } from '../../../reducers/function';
import { ENV_CONFIG } from '@/constants';

export const getMarketingAssociation = () => {
  return fetch({
    baseURL: ENV_CONFIG.JAVA_API_URL,
    url: '/laigu/marketing/ent_marketing_association/detail',
    method: 'POST'
  }).then(res => res.data.data);
};

export default function useMarketingPerm() {
  const dispatch = useDispatch();
  const state = useSelector(state => state.get('func'));

  const getMarketingPerm = useCallback(() => {
    getMarketingAssociation().then(res => dispatch(setMarketingPerm(res)));
  }, []);

  return { marketingPerm: state.get('marketingPerm'), getMarketingPerm };
}
